import _taggedTemplateLiteral from "/home/opc/is-monorepo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  query GetTaskStatuses {\n    taskStatuses {\n      id\n      code\n      name\n      description\n      final\n      forSalesman\n      priority\n    }\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
import gql from 'graphql-tag';
export var getTaskStatusesQuery = gql(_templateObject());